module.exports = __webpack_public_path__ + "img/2.6251b065.png";